export const booleanEquals = (value1, value2) => value1 === value2;
